import superAdminApi from "./superAdminApi";

const extractData = (res) => res?.data?.data ?? res?.data ?? null;

const extractMessage = (err, fallback) =>
  err?.response?.data?.message || err?.response?.data?.error || err?.message || fallback;

export async function fetchHubHomeSections() {
  const res = await superAdminApi.get("/super-admin/hub-home-sections");
  return extractData(res)?.sections ?? [];
}

export async function updateHubHomeSection(id, body) {
  const res = await superAdminApi.patch(`/super-admin/hub-home-sections/${id}`, body);
  return extractData(res)?.section ?? null;
}

export async function moveHubHomeSection(id, direction) {
  const res = await superAdminApi.post(`/super-admin/hub-home-sections/${id}/move`, { direction });
  return extractData(res)?.sections ?? [];
}

export async function reorderHubHomeSections(orderedIds) {
  const res = await superAdminApi.post("/super-admin/hub-home-sections/reorder", {
    ordered_ids: orderedIds,
  });
  return extractData(res)?.sections ?? [];
}

export { extractMessage as hubHomeSectionExtractMessage };
